var map = {
	"./emoji-agenda.svg": 1107,
	"./emoji-box.svg": 1108,
	"./emoji-camera.svg": 1109,
	"./emoji-capsule.svg": 1110,
	"./emoji-chat.svg": 1111,
	"./emoji-done.svg": 1112,
	"./emoji-facebook.svg": 1113,
	"./emoji-france.svg": 1114,
	"./emoji-grec.svg": 1115,
	"./emoji-instagram.svg": 1116,
	"./emoji-lampe.svg": 1117,
	"./emoji-laptop.svg": 1118,
	"./emoji-linkedin.svg": 1119,
	"./emoji-maroc.svg": 1120,
	"./emoji-messagerie.svg": 1121,
	"./emoji-money.svg": 1122,
	"./emoji-money2.svg": 1123,
	"./emoji-pen.svg": 1124,
	"./emoji-point.svg": 1125,
	"./emoji-smile.svg": 1126,
	"./emoji-smileSick.svg": 1127,
	"./emoji-stats.svg": 1128,
	"./emoji-tick.svg": 1129,
	"./emoji-write.svg": 1130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;